//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      position: null,
      mode: null,
      chips: []
    };
  },
  computed: {
    compiledText: function compiledText() {
      return Utils.format.markdown(this.spec.subtitle);
    }
  },
  methods: {
    $ready: function $ready() {
      var _this = this;

      var template = this.spec.template;
      this.mode = this.determineMode(template);
      this.chips = (this.spec.chips || []).map(function (spec) {
        var color = null;

        _this.$type.ifArray(spec.styleClasses, function (classes) {
          for (var _i = 0, _arr = ["success", "info", "warning", "error"]; _i < _arr.length; _i++) {
            var val = _arr[_i];

            if (classes.includes(val)) {
              color = val;
            }
          }
        });

        return Object.assign({}, spec, {
          color: color
        });
      });
    },
    determineMode: function determineMode(template) {
      switch (template) {
        case "commentIncoming":
        case "commentImageIncoming":
        case "commentVideoIncoming":
          return "incoming";

        case "commentOutgoing":
        case "commentImageOutgoing":
        case "commentVideoOutgoing":
          return "outgoing";

        case "systemComment":
          return "system";
      }
    }
  }
};